import React, { Component } from 'react';
import MetaTags from 'react-meta-tags';
import './App.css';
import detectBrowserLanguage from 'detect-browser-language'    
import ReactGA from 'react-ga';



class site extends Component{
    componentDidMount(){
        document.title = "Grant Wall - Community Manager"
        ReactGA.initialize('G-HJHX41GPXF');
        ReactGA.pageview('Home');
    }

    constructor(props){
        super(props);
        this.state = {
            currentLanguage: '',
            currentSection: 1,
            introPlayed: false
        }
        this.setLanguage = this.setLanguage.bind(this)
        this.setSection = this.setSection.bind(this)
        this.setPlayed = this.setPlayed.bind(this)
        //"en", "jp(ja)", "fr", "de", "ru", "cn(zh)", "vn(vi)", "kr(ko)"
        if (detectBrowserLanguage().slice(0,2) === "ja" && this.state.currentLanguage === ""){
            this.state.currentLanguage = "jp";
            ReactGA.event({
              category: 'Language',
              action: 'Default Language',
              value: "jp"
            });
        } else if (this.state.currentLanguage === "") {
            this.state.currentLanguage = "en";
            ReactGA.event({
              category: 'Language',
              action: 'Default Language',
              value: "en"
            });
        }
    }
    
    setSection(section){
        this.setState ({
            currentSection: section
        });
        window.scrollTo(0, 0);
    }
    
    setGame(game){
        this.setState ({
            currentGame: game
        });
    }
    
    setPlayed(){
        this.setState ({
            introPlayed: "true"
        });
    }

    setLanguage(language){
        this.setState ({
            currentLanguage: language
        });
        if (language === "en"){
            ReactGA.event({
              category: 'Language',
              action: 'Set Language',
              value: "en"
            });
        } else if (language === "jp"){
            ReactGA.event({
              category: 'Language',
              action: 'Set Language',
              value: "jp"
            });
        }
    }
    
    render() {
        //Localized Strings
        let title = {
            en: "Grant Wall - Community Manager",
            jp: "ウーオル・グラント ｜　コミュニティマネージャー"
        };
        let contentShown;      
        if (this.state.currentSection === 1){
            contentShown = <Home
            introPlayed = {this.state.introPlayed}
            setPlayed = {this.setPlayed}
            currentLanguage = {this.state.currentLanguage}/>;
            ReactGA.pageview('Home');
        } else if (this.state.currentSection === 2) {
            contentShown = <About
            currentLanguage = {this.state.currentLanguage}
            setSection = {this.setSection}/>;
            ReactGA.pageview('About');
        } else if (this.state.currentSection === 3) {
            contentShown = <Communities
            currentLanguage = {this.state.currentLanguage}
            setSection = {this.setSection}/>;
            ReactGA.pageview('Communities');
        } else if (this.state.currentSection === 4) {
            contentShown = <Resume
            currentLanguage = {this.state.currentLanguage}
            setSection = {this.setSection}/>;
            ReactGA.pageview('Experience');
        } else if (this.state.currentSection === 5) {
            contentShown = <Contact
            currentLanguage = {this.state.currentLanguage}
            setSection = {this.setSection}/>;
            ReactGA.pageview('Contact');
        } 
        
        
        return (
            <div className="main">
                <MetaTags>
                    <title>{title[this.state.currentLanguage]}</title>
                    <meta name="apple-mobile-web-app-capable" content="yes"/>
                    <meta name="apple-mobile-web-app-title" content="Grant Wall - Community Manager" />   
                    <meta name="application-name" content="Grant Wall - Community Manager" />
                    <meta name="description" content="Hello, I'm Grant. I'm a community manager with a wide variety of experiece over a broad range of titles." />
                    <meta name="viewport" content="width=device-width, initial-scale=1, viewport-fit=cover" />
                    <meta name="apple-mobile-web-app-capable" content="yes"/>

                </MetaTags>
                <Header
                    currentLanguage = {this.state.currentLanguage}
                    setLanguage = {this.setLanguage}
                />
                {contentShown}
                <Navigation
                    language = {this.state.currentLanguage}
                    setSection = {this.setSection}
                />
            </div>
        );
    }
}

class Header extends Component{
    constructor(props){
        super(props);
    }

    render() {
        return (
            <div id="header">
                <CountryButton
                    currentLanguage = {this.props.currentLanguage}
                    setLanguage = {this.props.setLanguage}
                />
            </div>
        );
    }
}

class Footer extends Component{
    constructor(props){
        super(props);
    }

    render() {
        return (
            <div id="footer">
                <span className="copyright">&copy;</span>2022 Grant Wall
            </div>
        );
    }
}

class Home extends Component{
    constructor(props){
        super(props);
        
    }

    playVideo1() {
        this.refs.vidRef1.play();
    }
    playVideo0() {
        if (this.props.introPlayed == false){
            this.props.setPlayed();
            setTimeout(() => {this.refs.vidRef1.play();}, 400);
        }
        
    }
    
    componentDidMount(){
        if (this.props.introPlayed == false){
            this.refs.vidRef1.focus();
            this.props.setPlayed();
            setTimeout(() => {this.refs.vidRef1.play();}, 1750);
        }    
    }

    render() {
        const mainLogo = require('./components/img/home/hello_' +this.props.currentLanguage +'.png')
        const avatarImg = require('./components/img/home/avatar_grant.jpg')
        const avatarVideo = require('./components/videos/home/avatar_grant.mp4')
        
        let title = {
            en: "I'm Grant",
            jp: "グラントと申します"
        };

        let subtitle = {
            en: "I manage communities",
            jp: "コミュニティマネージャーです"
        };
        


        
        return (
            <div id="home">
                    <div id="home-logo">
                        <div className="home-head">
                            <div className="avatars_png">
                                <img src={avatarImg} className="avatar_image" alt="Avatar"/>
                            </div>
                            <div className="avatars">
                                <video preload="auto" ref="vidRef1" className="avatar_video" onMouseOver={this.playVideo1.bind(this)}>
                                  <source src={avatarVideo} type="video/mp4"/>
                                </video>
                            </div>
                        </div>
                        <div id="home-titles">
                            <img src={mainLogo} className="main-logo" alt="Hello, I'm Grant"/>
                            <div id="homeTitle">{title[this.props.currentLanguage]}</div>
                            <div id="homeSubtitle">{subtitle[this.props.currentLanguage]}</div>
                        </div>
                    </div>
             
            </div>
        );
    }
}

class About extends Component{
    constructor(props){
        super(props);
        this.setSection = this.setSection.bind(this);
    }

    setSection(){
        this.props.setSection(1);
    }

    render() {        
        let title = {
            en: "about me",
            jp: "自分自身のついて"
        };
                     
        let nameGrant = {
            en: "Hello, I'm Grant",
            jp: "こんにちは、グラントと申します"
        };
                         
        let bioGrant = {
            en: "<p>My journey in Community Management began as a <b>Volunteer Forum Moderator</b> for <b>Nexon America</b>’s title <b>MapleStory</b>. In 2011, I was recognized by Nexon for <i>“[taking] community service to the next level, selflessly giving back to the community by providing guidance and aid to all Maplers -- in-game and out”</i> and was awarded the <b>Humanitarian Award</b> in their First Annual Community Awards.</p><p>Since that time I’ve continued to grow my career and expand my skill set while shaping and contributing to a number of vastly different communities.</p><p>In my current position at <b>Relic Entertainment (A SEGA Studio)</b>, I have been working on <b>Age of Empires IV</b>, supporting our Internal Community, Production, and Development Teams, as well as our <b>Microsoft Partners</b>. My duties have spanned a wide range, from organizing and supporting our pre-launch betas, planning and executing marketing beats, as well as owning all live-streaming activities for both Relic Entertainment, and the Age of Empires franchise channels.</p><p>Prior to that, in my position as <b>Community and Support Lead</b> at <b>A Thinking Ape</b>, I helped to shape the community of their latest game <b>Kingdoms of Heckfire</b> from the ground up. In addition to having my hands on the pulse of our communities, I led their Community and Support Team, and strived to provide the best experience possible for their players.</p><p>In my free time, I strive to better myself, learn, and grow through exercise, my Japanese language studies, and self-taught development and programming skills.</p><p>Some of my personal projects include this website (created from scratch in React), mobile development projects (found on my personal development studio page at <a href='https://aozame.com'>aozame.com</a>), and backend work on user moderation, as well as game and event management tools.</p>",
            jp:"<p>私のコミュニティ・マネジメントのキャリアは、<b>Nexon America</b>のタイトル<b>「MapleStory」</b>の<b>ボランティア・フォーラム・モデレーター</b>として始まりました。 2011年に、私はNexonから<i>「コミュニティサービスを次のレベルに引き上げ、ゲーム内外のすべてのメイプラーに指導や援助を行うことで無私の奉仕を行った」</i>と評価されて、第1回コミュニティアワードの<b>ヒューマニタリアン賞</b>を受賞しました。</p><p>それ以来、私は自分のキャリアを伸ばし、スキルセットを拡大しながら、多くの大きく異なるコミュニティを形成し、貢献してきました。</p><p>現在は<b>Relic Entertainment （SEGAスタスタジオです）</b>で<b>Age of Empires IV</b>に働いて、社内コミュニティ、制作、開発チーム、そして<b>Microsoftのパートナー</b>をサポートしています。発売前のベータを企画とサポートしたり、マーケティングビートを企画と実行したり、Relic EntertainmentとAge of Empiresフランチャイズチャンネルのライブストリーミングを担当したりと、幅広い職務をしています。</p><p>それ以前は、<b>A Thinking Ape</b>の<b>コミュニティ＆サポートリーダー</b>として、同社の最新ゲーム<b>「Kingdoms of Heckfire」</b>のコミュニティを立てました。コミュニティの鼓動を理解したことならび、コミュニティとサポートチームを率いて、プレーヤーに最高の体験を提供することに努めました。</p><p>自由時間には、運動や日本語の勉強し、プログラミングの自分自身を高め、学び、成長することに努めています。</p><p>数な自分のプロジェクトはこのウェブサイト（ゼロからReactで作りました）、モバイルデベロップメントプロジェクト（<a href=‘https://aozame.com'>aozame.com</a>という自分のスタジオサイトでもっと読める）、やユーザーモデレーション、ゲームとイベントマネジメント道具のようなバックエンドことです。</p>"
        };

        const bioAvatar = require('./components/img/pictures/grant.jpg')
        const mainLogo = require('./components/img/logos/' +this.props.currentLanguage +'.png')
        
        return (
            <div id="about">
                <div className="content">
                    <div id="logo">
                        <button onClick = {this.setSection}>
                            <img src={mainLogo} className="main-logo" alt="Grant Wall - Community Manager"/>
                        </button>
                    </div>
                    <div className="title">
                        {title[this.props.currentLanguage]}
                    </div>
                    <div className="bio-avatar">
                      <img src={bioAvatar}/>
                    </div>
                    <div className="subtitle">
                        {nameGrant[this.props.currentLanguage]}
                    </div>
                    <div id="about-box">
                       <div className="about-text" dangerouslySetInnerHTML={{__html: bioGrant[this.props.currentLanguage]}}></div>
                    </div>
                </div>
            </div>
        );
    }
}

class Communities extends Component{
    constructor(props){
        super(props);
        this.state = {popupVisible: false,
                      currentGame: 1,
                      numberOfGames: 15
        }
        this.setSection = this.setSection.bind(this);
        this.setPopupVisible = this.setPopupVisible.bind(this);
        this.setPopupHidden = this.setPopupHidden.bind(this);
        this.setCurrentGame = this.setCurrentGame.bind(this);
        this.escFunction = this.escFunction.bind(this);
    }
    
    componentDidMount(){
        document.addEventListener("keydown", this.escFunction, false);
    }
      
    componentWillUnmount(){
        document.removeEventListener("keydown", this.escFunction, false);
    }
    
    setPopupVisible(){
        this.setState({popupVisible: true});
    }
    
    setPopupHidden(){
        this.setState({popupVisible: false});
    }
    
    setCurrentGame(gameID){
        this.setState({currentGame: gameID});
        this.setPopupVisible();
    }
    
    nextGame(){
        if (this.state.currentGame == 1){
            this.setState({currentGame: this.state.numberOfGames});
        } else {
            this.setState({currentGame: this.state.currentGame-1});
        }
    }
    
    prevGame(){
        if (this.state.currentGame == this.state.numberOfGames){
            this.setState({currentGame: 1});
        } else {
            this.setState({currentGame: this.state.currentGame+1});
        }
    }

    setSection(){
        this.setState({currentGame: this.state.currentGame+1});
    }
    
    escFunction(event){
        if (event.key === "ArrowRight" && this.state.popupVisible) {
            this.nextGame();
        } else if (event.key === "ArrowLeft" && this.state.popupVisible){
            this.prevGame();
        } else if (event.key === "Escape" && this.state.popupVisible){
            this.setPopupHidden();
        }
      }
    
    render() {
        let title = {en: "current and past communities",
                     jp: "現在と過去のコミュニティー"};
                     
        const mainLogo = require('./components/img/logos/' +this.props.currentLanguage +'.png')
        
        let gameTitles = {
            15: "Age of Empires IV",
            14: "Age of Empires III: Definitive Edition",
            13: "Age of Empires II: Definitive Edition",
            12: "Kingdoms of Heckfire",
            11: "SMASH Monsters",
            10: "Kingdoms at War",
            9: "Meego Village",
            8: "Party In My Dorm",
            7: "Heva Clonia Online",
            6: "GunDog",
            5: "Heroes of the Realm",
            4: "Rumble Fighter",
            3: "Red Stone",
            2: "Zone 4",
            1: "MapleStory"
        };
        
        let companies = {
            15: "Relic Entertainment / Microsoft",
            14: "Relic Entertainment / Microsoft",
            13: "Relic Entertainment / Microsoft",
            12: "A Thinking Ape",
            11: "A Thinking Ape",
            10: "A Thinking Ape",
            9: "A Thinking Ape",
            8: "A Thinking Ape",
            7: "OGPlanet",
            6: "OGPlanet",
            5: "OGPlanet",
            4: "OGPlanet",
            3: "OGPlanet",
            2: "OGPlanet",
            1: "Nexon America"
        };
                         
        let platforms ={
            15: "PC",
            14: "PC",
            13: "PC",
            12: "Mobile",
            11: "Mobile",
            10: "Mobile",
            9: "Mobile",
            8: "Mobile",
            7: "PC",
            6: "PC",
            5: "PC",
            4: "PC",
            3: "PC",
            2: "PC",
            1: "PC"
        };
                         
        let detailsEn = {
            15: "One of the most beloved real-time strategy games returns to glory with Age of Empires IV, putting you at the center of epic historical battles that shaped the world. Featuring both familiar and innovative new ways to expand your empire in vast landscapes with stunning 4K visual fidelity, Age of Empires IV brings an evolved real-time strategy game to a new generation.<br><br>The past is prologue as you are immersed in a rich historical setting of 8 diverse civilizations across the world from the English to the Chinese to the Delhi Sultanate in your quest for victory. Build cities, manage resources, and lead your troops to battle on land and at sea in 4 distinct campaigns with 35 missions that span across 500 years of history from the Dark Ages up to the Renaissance.<br><br>Jump online to compete, cooperate or spectate with up to 7 of your friends in PVP and PVE multiplayer modes.<br><br>Developed by Relic Entertainment (a SEGA Studio) in partnership with World's Edge (a Microsoft Studio) and published by Xbox Game Studios, it’s the latest title in the Age of Empires franchise which has spanned more than 20 years.<br><h2>Awards</h2><b>Best PC Game</b> - Canadian Game Awards (2022)<br><b>Best Score/Soundtrack</b> - Canadian Game Awards (2022)<br><b>Best Sim/Strategy Game</b> - The Game Awards (2021)<br><b>Best Strategy Game</b> - Gamescom (2021)<br><h2>Nominated</h2><b>Best Art Direction</b> - Canadian Game Awards (2022)<br><b>Best Audio Design</b> - Canadian Game Awards (2022)<br><b>IGN People’s Choice Award</b> - Gamescom (2021)<br><b>Best Game You Suck At</b> - Steam Awards (2021)",
            14: "Age of Empires III: Definitive Edition completes the celebration of one of the most beloved real-time strategy franchises in definitive form with enhanced features and modernized gameplay.<br><br>Command mighty civilizations from across Europe and the Americas or jump to the battlefields of Asia in stunning 4K Ultra HD graphics and with a fully remastered soundtrack.<br><br>Now featuring two new game modes: Co-Op Historical Battles and The Art of War Challenge Missions, including all previously released expansions and all 14 civilizations, plus two brand new civilizations – the Swedes and Inca.<br><br>Head online to challenge other players with updated online multiplayer with cross network play and enjoy modern gaming features including spectator modes and mod support.<br><br>Complete your collection with this final chapter in the Age of Empires Definitive Edition journey.",
            13: "Age of Empires II: Definitive Edition celebrates the 20th anniversary of one of the most popular strategy games ever, now with stunning 4K Ultra HD graphics, and a fully remastered soundtrack. Age of Empires II: DE features “The Last Khans” with 3 new campaigns and 4 new Civilizations. Frequent updates include events, additional content, new game modes, and enhanced features with the recent addition of Co-Op mode!<br><br>Explore all the original Campaigns and the best-selling expansions like never before. With over 200 hours of gameplay and 1,000 years of human history, improved experiences await. Head online to challenge other players in your quest for world domination with 35 different Civilizations. You can also experience new Civilizations and Campaigns with the Lords of the West DLC! Recent updates include a Battle Royale game mode, ongoing support for the Scenario Editor, Quick Play for easy social games, enhancements to the game UI, and more! <br><br>Choose your path to greatness with an eye-catching and engaging remaster to one of the most beloved strategy games of all time.",
            12: "Build your Kingdom, train your Dragons and start destroying things today. Goblins! Skeletons! People with weird Moustaches! Battle them all in this RTS mobile MMO kingdom game! Now with 4x more content. Feel the thrill of real time crusades!<br><br>The ultimate Kingdom Empire game on the planet. Find the best strategy to attack the Enemies Kingdoms. Either defeat them or be defeated. This is a real-time City building & strategy game that looks easy but requires substantial brainpower. Most Kingdom Empire games are fun but this city building game is on another level. The most fun and addicting War strategy Kingdom building game is right on your sight waiting for you to join.<br><br>Rip through the realm competition and shed some blood, sweat and tears by engaging in medieval kingdom game battles using your kingdom guard and their mighty Dragons! You won’t have a chance to rest once you’re done terrorizing your neighbors either because new Raids and Dragon Booty equipment have been added to your kingdom’s arsenal. Increase that fire power today & Create your own empire in this city building game and see the rise of your kingdom!<br><br>Kingdoms of Heckfire is a multiplayer war strategy game. As a king, you need to build and upgrade a variety of buildings to build your stronghold, gradually building a mighty dragon army to defend your empires. This online Empire game is very special, it implements fresh and interesting rules, well-designed city Building game mechanics that allow you to enjoy the fun of a real war strategy game. Make your Kingdom rise & become one of the best world warriors.<br><br>A treasure trove of new features has been added in this army MMO Empire building game. Check out the 4x more kingdom game content we’ve been working on below!<br><br><b>FEATURES</b><br><ul><li>A medieval inspired real time, open world map filled with dragon monsters and pvp players from around the world!</li><li>Hatch and raise a powerful Dragon army to strike fear into your enemies hearts (and other bloody organs) to build a kingdom for a king!</li><li>Complete epic quests issued by a semi nude wizard who lives in your kingdom!</li><li>Engage in kingdom games by creating powerful Clans and Alliances to rule the realms of Heck Fire!</li><li>Train your kingdom guard with new Dragon Booty equipment upgrades, adding further RTS strategy depth to your gameplay! If your pvp enemies want fire and blood, they can expect both!</li><li>Up your kingdom game! Construct medieval buildings faster with the added Second Kingdom Builder mechanic then dominate in city building pvp battles!</li><li>Battle well groomed Titan monsters for massive amounts of medieval loot! Possibly even rare treasure for raining hellfire on the competition!</li><li>Can’t stand enemy fire, get out of the realm with our new Realm to Realm Transfer Token! Elevate your kingdom game by starting fresh in a different realm with new threats and rewards. Once you upgrade enough, use the Realm Transfer Token to explore other realms and chase your enemy’s kingdom down!</li><li>Fresh kingdom and Clan wide Raids await with increasing MMO strategy difficulty!</li><li>Rise through the ranks with dynamic Event schedules! Build up your empire wins and compete in elite SLG style gameplay leaderboards!</li><li>Tournaments and evolving pvp mechanics such as Dragon lethality weaknesses ensure this army MMO will constantly challenge your kingdom games strategy. So stay on your toes or RIP!</li></ul>",
            11: "Welcome, SMASH Agent. Create epic monsters and evolve them into an unstoppable army. Build your city to defend against invading monsters while battling players around the world for world domination. Show no mercy!<br><br><b>FEATURES</b><br><ul><li>Lead your monster army to victory against other players in a massively multiplayer PvP world!</li><li>Tons of epic monsters to collect, feed, and evolve!</li><li>Build unbeatable tower defenses to fend off rival SMASH agents! Craft unique defense blueprints!</li><li>Defeat powerful SMASH bosses as you conquer the world in campaign mode.</li><li>Strategize and chat with other players in real-time!</li></ul>",
            10: "Lead the mightiest army in the kingdom! Intense player vs. player MMORPG with epic clan wars, and battles! Face-off against millions of players, destroy their kingdom, claim new lands, battle ancient monsters, and seize rare items! Join a clan, fight your friends, and dominate in live PVP events! Who will be your ally in your mighty quest for domination!<br><br>No other MMORPG let's you hit anyone, anytime! <br><br>Power is yours for the taking! Form a Clan, hire allies, and plunder gold in Kingdoms at War: the ultimate fantasy-strategy game. Team up to defeat ancient monsters in Epic Battles, or fight against other players and destroy their kingdom. Play the ally market and hire your friends!<br><br>Command your army and prove your worth on the battlefield: CLAIM YOUR KINGDOM NOW! Play KINGDOMS AT WAR!<br><br><b>FEATURES</b><ul><li>Regular FREE updates with live PVP events and leaderboards!</li><li>Join forces to form a powerful Clan and crush the competition!</li><li>Scout, assassinate, and steal from enemy kingdoms</li><li>Build your kingdom with Catapults, Watch Towers, and Dragons!</li><li>Choose your banner: Conqueror, Monarch or Defender </li><li>Use magical elixirs and powerful spells against your enemies</li><li>Visit the Mage to enchant your weapons and increase their power</li><li>Lead Epic Battles against ancient monsters</li><li>Battle rival players LIVE in REAL TIME!</li><li>Open ally market, hire anyone at anytime to aid in your quest!</li><li>...and much MORE!</li></ul>",
            9: "MEET THE MEEGO - wacky, volcano-dwelling villagers who need your help. Watch them grow from babies to adults, fall in love, and build the most epic village!<br><br><b>FEATURES</b><ul><li>Assign Meego to jobs and see them improve over time!</li><li>Watch your Meego grow from babies to adults, fall in love, and grow old!</li><li>Name and customize your Meego with hilarious items!</li><li>Build quirky buildings and yummy food stands</li><li>Launch Meego into the air to travel from your Launch Dock</li><li>Collect rare birthstones by strategically breeding villagers </li></ul>",
            8: "Hang with your crew in the best college game ever. Tear up a house party, collect swag, chat with cute girls, flirt with your favorite eboy, or just chill with your best friends. You can roleplay, send gifts, adopt a pet, decorate your room, or even start a relationship and go on dates!<br><br>Love college chat games with avatars? We have tons of avatars! You can be a Kpop star, a muscle bound gym daddy, a playful brat kitten, an Emo DJ or just a house party hero and many more!<br><br><b>FEATURES</b><ul><li>Decorate your college dorm room like your inner designer desires. Whether your style is Skate Park, Japanese Anime, VIP Lounge, or the Dark Arts - you can have it all and take part in dorm design contests!</li><li>Rent out dorm rooms and hire a squad, then upgrade their skills and challenge other squads to a dance fight.</li><li>1000+ avatars to choose from - like Sorority Girl, Frat Bro, Vogue Fashion Fanatic, or the girl who loves Pumpkin Spice a little TOO much.</li><li>What’s your sign, baby? Aries? Gemini? Up your zodiac game with #aesthetic items in theme of your zodiac sign!</li><li>Start a relationship, then break up to find someone new. Be single or date around and get personal. Your college love match is bound to be more exciting than any dating site or dating app!</li><li>Group chat is more fun with college chat games! You can roleplay, send stickers, ask the magic 8 ball, spin the bottle, and more!</li><li>Adopt a pet like a pug, a goose, or a rabbit. Dress them up in cute outfits. Sorry, Joseph Gordon Rabbit, do it for the gram!</li></ul>",
            7: "Get whisked away into the fantasy dream world of Heva Clonia Online, an MMORPG from Windysoft. In HCO, you can explore in a special campaign mode, or join up with friends in team play, two-player dungeons, and even guild warfare. Become a mad scientist as you clone creatures of the world to serve as your pets, or put yourself to work crafting the latest equipment.<br><br><u>Clone and Battle:</u> Players can create replicas of monsters they face in the wild, they train them as their own to do battle against dungeons or other players.<br><br><u>Couple Focused Teamwork:</u> Looking to have a good time in an MMO with just your close buddy or significant other? Heva Clonia caters various dungeons for two player co-op action.<br><br><u>Guilds and War:</u> Climb your way up the leaderboard in large scale guild versus guild battles to prove the worth of your faction.<br><br><u>Mini-Games:</u> All grind and no downtime can burn you out fast. Take a breather and play a variety of mini-games to keep your mind off saving the world for a while.",
            6: "Get started in the Animal World War!<br><br>GunDog is a comic-book style third-person shooter published by OGPlanet. <br><br>In GunDog, players enlist into battle, not as regular soldiers, but as bipedal dogs engaged in the Animal World War. Through competitive matches, players are able to collect and unseal card packs, in hopes of obtaining loadout and character cards. These cards unlock new characters, visual skins, as well as class specific weapons and abilities. Players are then able to further progress their characters and class bonuses by gaining experience and levelling up.<br><br>GunDog offers several gameplay modes including TDM, Demolition, and Stealth.",
            5: "Heroes of the Realm is a 2D side-scrolling MMORPG developed by South Korean studio Bluceansoft. It combines a collectible card game with turn-based strategy set in a fantasy world.<br><br>With more than 350 unique heroes to do battle with, players can collect, combine, and enchant their way to victory through formations, hero squads, and more! Adjustable battle AI settings allow players to maximize their strategy in battle as they engage with other players in direct PvP combat within the Arena and Colosseum. <br><br>Enchant and unlock special heroes that can be used to turn the tides of war, as you become the Hero of the Realm!",
            4: "Rumble Fighter is free-to-play, casual MMO fighting game from Nimonix and OGPlanet that lets players take on each other or group up to fight in teams. Players select from pre-made character types based upon their ability to use certain Sacred Scrolls, or fighting styles, which include Kung Fu, Taekwondo, and Jujitsu. The game has a system called ExoCore that lets characters transform physically, become stronger temporarily and unleash special attacks. The ability to customize characters a bit exists through the use of items, some of which are premium from the cash shop.<br><br><u>Six Character Classes:</u> Choose from the Striker, Soul Fighter, Elementalist, Alchemist, Shaman, and Android character classes.<br><br><u>Multiple Game Modes:</u> Engage in different game modes such as Battle Mode, Adventure Mode, Survival Mode, and Rumble Mode - which covers a variety of modes from all-out massive brawls to challenges like King of the Hill.<br><br><u>Sacred Scrolls:</u> Employ a variety of Sacred Scrolls to choose between different unique fighting styles.<br><br><u>ExoCore System:</u> Utilize ExoCores to transform your character's appearance and abilities and gain powerful attacks.",
            3: "Red Stone is an online 2D fantasy MMORPG developed by L&K and published by OGPlanet.<br><br>Players can select from eight unique character classes, each of which possess the ability to transform into alternate sub-classes in battle, bringing with them varying skills and abilities. In the world of Red Stone you will explore dangerous lands, fight powerful monsters, complete exciting quests, and battle others guilds in search of glory.",
            2: "Zone 4: Fight District is a free-to-play massively multiplayer online fighting game developed by Infovine and published by OGPlanet. <br><br>With fast-paced street fighting taking place in an urban environment, Zone 4 combines the arcade style of classic games like Double Dragon and Final Fight with the complex strategy of modern brawlers like Street Fighter and Super Smash Bros. Brawl. <br><br>Players are also able to fully customize their characters with unique costumes, exotic weaponry, and powerful new brawlers.",
            1: "Welcome to MapleStory, the original side-scrolling MMORPG (with over 260 Million Global Players) where epic adventure, action and good friends await you. With hundreds of hours of gameplay, this immersive role-playing experience will allow you to conquer perilous dungeons, overcome terrifying bosses, socialize with your friends and much more. <br><br>Featuring an iconic 2D art style, MapleStory offers the thrill of explosive power, bold anime-style self-expression, and absolute control of your characters’ awesome abilities. Build your perfect custom hero from over 40 distinct classes with thousands of unique cosmetic options, and set off on your journey to face never-ending challenges and enjoy extraordinary rewards. <br><br>Create a gaming experience as unique as your personality by designing your own MapleStory hero. With over 40 unique classes to choose from, each with their own amazing abilities as well as an almost limitless number of cosmetic options, your hero will truly become one-of-a-kind. Become a leader in the Maple Alliance and a legendary hero to inspire players for years to come. <br><br>Immerse yourself in Maple World’s rich lore-filled history and epic storylines as you traverse lush forests, arid deserts, frozen tundras, underwater kingdoms, lost civilizations, and even a city in the sky! With hundreds of locations to roam, secrets to discover, and bosses to master, MapleStory offers a wealth of gameplay for you to uncover.<br><br>Discover Your Story!"
        }
        
        let detailsJp = {
            15: "Age of Empires IVは、最も人気のあるリアルタイムストラテジーゲームの1つが栄光を取り戻って、世界を形作った壮大な歴史的戦いの中心にあなたを置いています。Age of Empires　IVは、広大な土地で帝国を拡大するための、おなじみの方法と革新的な新しい方法の両方を、圧倒的な4Kのビジュアルで実現し、進化したリアルタイムストラテジーゲームを新世代の人々にお届けしています。<br><br>イギリス、中国、デリー・スルタンなど、世界8カ国の多様な文明が織りなす豊かな歴史設定の中で、勝利のために過去に浸ることができます。暗黒時代からルネッサンスまで、500年の歴史にまたがる35のミッションからなる4つのキャンペーンで、都市を建設し、資源を管理し、陸と海で軍隊を率いて戦いに挑みましょう。<br><br>オンラインでPVPとPVEマルチプレイヤーモードで最大7人の友人と競争、協力、観戦することができます。<br><br>Relic Entertainment（Segaのスタジオ）がWorld's Edge（Microsoftのスタジオ）と共同で開発し、Xbox Game Studiosがパブリッシングした本作は、20年以上にわたるAge of Empiresフランチャイズの最新作となります。<br><h2>アワード</h2> <b>最優秀PCゲーム賞</b> - カナダ・ゲーム・アワード（2022年)<br><b>最優秀スコア／サウンドトラック賞</b> - カナダ・ゲーム・アワード（2022年)<br><b>最優秀シム・ストラテジーゲーム賞</b> - ザ・ゲーム・アワード（2021年)<br><b>最優秀ストラテジーゲーム賞</b> - ゲームズコム（2021年)<br><h2>ノミネート</h2><b>最優秀アートディレクション賞</b> - カナダ・ゲーム・アワード（2022年)<br><b>最優秀オーディオデザイン</b> - カナダ・ゲーム・アワード（2022年)<br><b>IGNピープルズチョイスアワード</b> - ゲームズコム（2021年)<br><b>あなたが一番下手にゲーム</b> - スチーム・アワード（2021年)<br>",
            14: "Age of Empires III: Definitive Editionは、最も人気のあるリアルタイムストラテジーゲームの1つである本作を、より充実した機能と最新のゲームプレイを備えた決定版として完成させたものです。<br><br>ヨーロッパ、アメリカ大陸の強大な文明を指揮し、アジアの戦場へ飛び込もう！圧倒的な4K Ultra HDグラフィックとフルリマスターサウンドトラックでお届けします。<br><br>2つの新しいゲームモードが追加されました: 共闘歴史バトルとThe Art of Warチャレンジミッション。また、過去に発売されたすべての拡張コンテンツと全14文明に加え、スウェーデンとインカの2つの新文明を収録しています。<br><br>オンラインでは、クロスネットワークプレイに対応した最新のオンラインマルチプレイで他のプレイヤーに挑戦し、観戦モードやMODサポートなど最新のゲーム機能を楽しむことができます。<br><br>Age of Empires Definitive Editionの最終章を、ぜひお楽しみください。",
            13: "Age of Empires II: Definitive Editionは、史上最も人気のあるストラテジーゲームの1つの20周年を記念し、見事な4K Ultra HDグラフィックスとフルリマスターサウンドトラックを搭載しています。Age of Empires II：DEでは、3つの新キャンペーンと4つの新文明を含む「The Last Khans」が登場します。イベントや追加コンテンツ、新しいゲームモード、Co-opモードの追加など、頻繁に行われるアップデートで機能が強化されています。<br><br>すべてのオリジナルキャンペーンとベストセラーの拡張版で、これまでにない体験をしよう。200時間を超えるゲームプレイと1,000年にわたる人類の歴史が、さらに進化した体験を待っています。オンラインで他のプレイヤーと対戦し、35種類の文明で世界征服を目指します。また、「Lords of the West」DLCでは、新しい文明とキャンペーンを体験することができます 。最近のアップデートでは、バトルロイヤルゲームモード、シナリオエディターの継続的なサポート、ソーシャルゲームを簡単に楽しめるクイックプレイ、ゲームUIの強化などが行われました。<br><br>偉業への道を選択しよう！最も人気のあるストラテジーゲームの1つである本作を、魅力的なリマスターとして生まれ変わらせ、偉大なる存在へと導きます。",
            12: "王国を築き、ドラゴンを育成し、今日から破壊の旅に出よう。ゴブリン! スケルトン! 変な口ひげの人たち! このRTSモバイルMMO王国ゲームで彼らと戦おう! 4倍のコンテンツが追加されました。リアルタイムの十字軍のスリルを味わおう!<br><br>地球上で究極のキングダム エンパイア ゲーム。敵の王国を攻撃する最高の戦略を見つけよう。敵を倒すか、倒されるか。 簡単そうに見えて、かなりの頭脳を必要とするリアルタイム都市建設＆戦略ゲームです。ほとんどのキングダム エンパイア ゲームは楽しいですが、この都市建設ゲームは別のレベルです。最も楽しくて病みつきになる戦争戦略キングダムビルディングゲームがあなたの視界に入り、参加するのを待っています。<br><br>王国の守護者と強力なドラゴンを使って中世の王国ゲームの戦いに参加し、レルム競争を勝ち抜き、血と汗と涙を流そう! 新しいレイドとドラゴン戦利品が王国の武器に追加されたので、隣人を恐怖に陥れた後も休む暇はない。今すぐ火力を上げて、この都市建設ゲームで自分の帝国を作り、あなたの王国の隆盛を見届けよう!<br><br>Kingdoms of Heckfireは、多人数参加型の戦争戦略ゲームです。王として、あなたは、あなたの帝国を守るために徐々に強大な竜の軍隊を構築し、あなたの砦を構築するために、様々な建物を構築し、アップグレードする必要があります。このオンライン帝国ゲームは非常に特別です、それはあなたが本当の戦争戦略ゲームの楽しさを楽しむことができる新鮮で面白いルール、よく設計された都市建物のゲームの力学を実装しています。あなたの王国を上昇させ、世界の一番戦士なりなさい。<br><br>新機能の宝庫が追加された軍隊MMO帝国構築ゲームです。4倍増の王国ゲームコンテンツは下記よりご確認ください。<br><br><b>ゲームフィーチャー</b><br><ul><li>中世をイメージしたリアルタイムオープンワールドマップで、ドラゴンモンスターや世界中のプレイヤーとのPvPが楽しめます！</li><li>ドラゴンを孵化させて育て、敵の心臓を恐怖に陥れ、王のための王国を築き上げよう！</li><li>あなたの王国に住むセミヌードの魔法使いが出す壮大なクエストをクリアしよう！</li><li>強力なクランやアライアンスを作り、Heckfireの王国を支配するために、王国ゲームに参加しよう！</li><li>新しいドラゴン戦利品装備のアップグレードで王国警備隊を訓練し、ゲームプレイにさらなるRTS戦略の深みを加えよう! PvPの敵が炎と血を求めるなら、その両方を期待できる！</li><li>あなたの王国ゲームをアップグレードしよう！ 追加されたセカンドキングダムビルダーで中世の建物をより早く建設し、都市建設PvPバトルで優位に立とう！</li><li>イケメン巨人モンスターとバトルして大量の中世の戦利品をゲット! 対戦相手に地獄の火炎を降らせれば、レアなお宝が手に入るかも！</li><li>敵の攻撃に耐えられなくなったら、新しいレルム間移動トークンでレルムを出ましょう！レルムからレルムへ移動することで、新しい脅威と報酬のある別のレルムで再出発することで、あなたの王国ゲームを向上させましょう。十分にアップグレードしたら、レルム転送トークンを使って他のレルムを探検し、敵の王国を追い詰めよう！</li><li>MMO戦略の難易度が上がり、新たな王国やクラン単位のレイドが待っている！</li><li>ダイナミックなイベントスケジュールでランクアップを目指そう SLGスタイルのゲームプレイリーダーボードで競い合い、勝利を積み重ねよう！</li><li>トーナメントや、ドラゴンの致命的な弱点など、進化するPvPの仕組みは、この軍隊MMOがあなたの王国ゲームの戦略に常に挑戦することを保証します。だから、あなたのつま先やRIPに滞在してください！</li></ul>",
            11: "ようこそ、SMASH Agent。壮大なモンスターを創造し、止められない軍隊に進化させる。侵略してくるモンスターから街を守りながら、世界征服のために世界中のプレイヤーとバトルを繰り広げよう。慈悲はないのか!<br><br><b>ゲームフィーチャー</b><br><ul><li>多人数参加型のPvPワールドで、モンスター軍団を率いて他のプレイヤーに勝利しよう!</li><li>大量のエピックモンスターを集めて、餌を与えて、進化させよう!</li><li>ライバルの「SMASH Agents」を撃退するため、無敵のタワーを建設せよ! ユニークな防衛設計図を作ろう!</li><li>キャンペーンモードでは、強力なSMASHボスを倒しながら、世界を征服していきます</li><li>他のプレイヤーとリアルタイムで戦略やチャットを楽しむことができます</li></ul>",
            10: "王国最強の軍隊を率いよう! 壮大なクラン戦争やバトルが楽しめるプPvPのMMORPG! 数百万人のプレイヤーと対戦し、王国を破壊し、新しい土地を要求し、古代のモンスターと戦い、レアアイテムを手に入れよう! クランに所属し、仲間と戦い、ライブPvPイベントで勝利を収めよう! あなたの強大な征服のために、誰があなたの味方になるのでしょうか!<br><br>他のMMORPGにはない、いつでも誰とでも殴り合える!<br><br>権力はあなたのもの! 「Kingdoms at War」は、究極のファンタジーストラテジーゲームです。 チームを組んで古代のモンスターを倒すエピックバトルや、他のプレイヤーと戦って彼らの王国を破壊することもできます。同盟国マーケットから友人を雇いましょう!<br><br>軍隊を指揮し、戦場で自分の価値を証明しよう。今すぐあなたの王国を取り戻そう！KINGDOMS AT WARをプレイ!<br><br><b>ゲームフィーチャー</b><ul><li>ライブPVPイベントやリーダーボードなど、定期的な無料アップデートを実施!</li><li>力を合わせて強力なクランを結成し、競争相手を粉砕せよ!</li><li>敵国からのスカウト、暗殺、盗みを行う</li><li>カタパルト、ウォッチタワー、ドラゴンを使って王国を築き上げよう</li><li>バナーを選んでください。征服者、君主、守護者 </li><li>魔法のエリクサーと強力なスペルを使って敵を倒そう</li><li>魔道士を訪ねて、武器をエンチャントしてパワーをアップさせよう</li><li>古代のモンスターと壮大なバトルを繰り広げる</li><li>リアルタイムでライバルと対戦！</li><li>オープンな味方市場、いつでも誰でも雇って冒険の手助けをしてくれる！？</li><li>などなど</li></ul>",
            9: "MEEGOに会う！ <br><br>火山に住む不思議な村人たち。赤ちゃんから大人へと成長し、恋に落ち、最も壮大な村を作り上げるのです。<br><br><b>ゲームフィーチャー</b><ul><li>Meegoに仕事を割り当て、時間が経つにつれて改善されていく様子をご覧ください</li><li>赤ちゃんから大人へ、恋をして、老いていくMeegoの成長を見守りましょう</li><li>Meegoに名前をつけて、愉快なアイテムでカスタマイズしよう!</li><li>風変わりな建物とおいしい屋台を作る</li><li>Meegoを空中に飛ばして、Launch Dockから旅に出よう</li><li>村人を戦略的に繁殖させ、希少な誕生石を集めよう</li></ul>",
            8: "史上最高のカレッジゲームで仲間と一緒に遊ぼう。ハウスパーティーを盛り上げたり、スワッグを集めたり、かわいい女の子とおしゃべりしたり、お気に入りの男の子とイチャイチャしたり、親友と一緒にのんびり過ごしたり。 ロールプレイをしたり、プレゼントを送ったり、ペットを飼ったり、部屋を飾ったり、さらには交際を始めてデートをしたりすることも可能です<br><br>アバターで大学のチャットゲームが好き？アバターが山ほどあります。KPOPスター、筋肉隆々のジムパパ、遊び盛りの子猫、エモDJ、ハウスパーティヒーローなどなど、たくさんのアバターがあります。<br><br><b>ゲームフィーチャー</b><ul><li>大学の寮の部屋を、あなたの中のデザイナーが望むように飾り付けましょう。スケートパーク、日本アニメ、VIPラウンジ、ダークアーツなど、あなたのスタイルに合わせて、寮のデザインコンテストに参加してください</li><li>寮の部屋を借りて隊員を雇い、隊員のスキルをアップグレードして他の隊員にダンスファイトを挑みます</li><li>1000種類以上のアバターから選択可能 - 女子学生、社交クラブの男子、ヴォーグファッションマニア、パンプキンスパイスがちょっと大好きなすぎて女の子など</li><li>あなたの星座は何ですか？おひつじ座？双子座？あなたの星座をテーマにした#美的アイテムで、星座ゲームを盛り上げよう!</li><li>交際を始めて、別れて新しい人を探す。独身でいるか、デートして個人的に付き合うか。あなたの大学時代の恋のお相手は、どんな出会い系サイトや出会い系アプリよりも盛り上がるはずです!</li><li>カレッジチャットゲームでグループチャットがもっと楽しくなる! ロールプレイ、ステッカー送信、マジック8ボールへの質問、ボトル回しなど、様々なことができます!</li><li>パグ、ガチョウ、ウサギなどのペットを飼う。かわいい服を着せてあげましょう。ジョセフ・ゴードン・ラビット、ごめんなさい</li></ul>",
            7: "WindysoftのMMORPG、Heva Clonia Onlineでファンタジーの夢の世界へと誘われましょう。HCOでは、特別なキャンペーンモードで探索したり、チームプレイや2人用ダンジョン、ギルド戦などで友達と協力することも可能です。マッドサイエンティストになって、世界中の生き物のクローンを作ってペットにしたり、最新の機器を作ったりしてみましょう。<br><br><u>クローンとバトル：</u> プレイヤーは、野生で出会ったモンスターのレプリカを作成し、自分だけのモンスターとして育成し、ダンジョンや他のプレイヤーとバトルを繰り広げることができます。<br><br><u>2人での協力プレイ；</u> 親しい仲間や大切な人と一緒にMMOで楽しい時間を過ごしたい？Heva Cloniaでは、2人での協力プレイが可能な様々なダンジョンが用意されています。<br><br><u>ギルドと戦争：</u> 大規模なギルド対ギルドのバトルでリーダーボードに上り詰め、自分の派閥の価値を証明しましょう。<br><br><u> ミニゲーム ：</u> 仕事ばかりで遊びがないと、すぐに燃え尽きてしまいます。一息ついて、さまざまなミニゲームをプレイして、しばらくの間、世界を救うことから目をそらそうようにしましょう。",
            6:"アニマル世界大戦を始めましょう<br><br>GunDogは、OGPlanetから発売されたコミックスタイルのサードパーソン・シューティングゲームです。<br><br>ガンドッグには、プレイヤーが普通の兵士ではなく、二足歩行の犬として「動物世界大戦」に参加する。対戦を通じて、プレイヤーはカードパックを収集・開封し、ロードアウトやキャラクターカードの入手を目指します。これらのカードによって、新しいキャラクターやビジュアルスキン、クラス固有の武器やアビリティがアンロックされます。そして、プレイヤーは経験値を得てレベルアップすることで、キャラクターやクラスボーナスをさらに進化させることができるのです。<br><br>GunDogには、TDM、Demolition、Stealthなど、複数のゲームモードがあります。",
            5: "Heroes of the Realmは、韓国のスタジオBluceansoftによって開発された2Dの横スクロールMMORPGです。ファンタジーの世界を舞台にしたターン制ストラテジーとコレクティブルカードゲームを融合させた作品です。<br><br>350体以上のユニークなヒーローを集め、合成し、エンチャントして、フォーメーションやヒーロースクワッドなど、勝利への道を切り開きます。アリーナやコロシアムで他のプレイヤーと直接戦うPvPでは、バトルAIの設定を調整することで、プレイヤーは自分の戦略を最大限に生かしたバトルを行うことができます。<br><br>エンチャントして特別なヒーローをアンロックし、戦況を変えることができます。",
            4: "Rumble Fighterは、Nimonix社とOGPlanet社が共同開発した基本プレイ無料のカジュアルMMO格闘ゲームで、プレイヤー同士が対戦することも、チームを組んで戦うことも可能です。プレイヤーは、特定の聖なる巻物や、カンフー、テコンドー、柔術などの戦闘スタイルを使用する能力に応じて、あらかじめ用意されたキャラクタータイプを選択します。このゲームには、キャラクターが物理的に変形し、一時的に強くなったり、特殊な攻撃を繰り出すことができる「エクソコア」というシステムが搭載されています。キャラクターを少しカスタマイズできるアイテムが存在し、その中にはキャッシュショップで購入できるプレミアムなものもあります。<br><br><u>6つのキャラクタークラス：</u> ストライカー、ソウルファイター、エレメンタリスト、アルケミスト、シャーマン、アンドロイドのキャラクタークラスから選択可能です。<br><br><u>複数のゲームモード：</u> バトルモード、アドベンチャーモード、サバイバルモード、ランブルモードなど、さまざまなゲームモードがあり、大乱闘からキングオブヒルのようなチャレンジまで、さまざまなモードが楽しめます。<br><br><u>セイクリッド・スクロールズ：</u> 様々なセイクリッド・スクロールを使って、個性的な戦闘スタイルを選択することができます。<br><br><u>エクソコアシステム：</u> エクソコアを活用することで、キャラクターの外見や能力を変化させ、強力な攻撃を身につけることができます。",
            3: "Red Stoneは、L&Kが開発し、OGPlanetがパブリッシングしたオンライン2DファンタジーMMORPGです。<br><br>プレイヤーは8つのユニークなキャラクタークラスから選ぶことができ、それぞれのクラスは戦闘中に別のサブクラスに変身し、様々なスキルや能力を発揮します。Red Stoneの世界では、危険な土地を探索し、強力なモンスターと戦い、エキサイティングなクエストをこなし、他のギルドと戦い、栄光を手に入れることができます。",
            2: "Zone 4: Fight DistrictはInfovineが開発し、OGPlanetがパブリッシャーとなった、無料プレイの多人数同時参加型オンライン格闘ゲームです。<br><br>都市環境で繰り広げられるテンポの良いストリートファイトが特徴の「Zone 4」は、「ダブルドラゴン」や「ファイナルファイト」といったクラシックゲームのアーケードスタイルと、「ストリートファイター」や「大乱闘スマッシュブラザーズBRAWL」といった現代の格闘ゲームの複雑な戦略性を融合させた作品となっています。<br><br>また、ユニークなコスチュームやエキゾチックな武器、強力な新武器など、キャラクターをフルカスタマイズすることができます。",
            1: "MapleStoryへようこそ！壮大な冒険、アクション、そして親友があなたを待っている、オリジナルの横スクロールMMORPG（全世界2億6000万人以上）です。何百時間ものゲームプレイが可能なこの没入型ロールプレイングゲームでは、危険なダンジョンを攻略し、恐ろしいボスを倒し、友人と交流するなど、さまざまな体験をすることができます。<br><br>MapleStoryは、象徴的な2Dアートスタイルを採用し、爆発的なパワー、大胆なアニメスタイルの自己表現、そしてキャラクターの素晴らしい能力を完全にコントロールするスリルを提供します。40種類以上のクラスと数千種類のコスチュームから、自分だけのヒーローを作り上げ、果てしない挑戦と特別な報酬を得るために旅に出よう。<br><br>MapleStoryのヒーローをデザインすることで、あなたの個性に合わせたゲーム体験ができます。40種類以上のクラスから選択でき、それぞれに素晴らしい能力があり、コスチュームオプションもほぼ無制限で、あなたのヒーローはまさにオンリーワンになるでしょう。 メイプルアライアンスのリーダーとして、プレイヤーに感動を与える伝説のヒーローになりましょう。<br><br>緑豊かな森、乾燥した砂漠、凍てつくツンドラ、海底王国、失われた文明、そして天空の都市まで、MapleStoryの豊かな歴史と壮大なストーリーに没頭してください。MapleStoryでは、何百ものロケーションを歩き回り、秘密を発見し、ボスを攻略することで、豊富なゲームプレイを楽しむことができます。<br><br>あなたの物語を見つけよう！"
        }
        
        let details = {}; 
        
        if (this.props.currentLanguage == "en"){
            details = detailsEn;
        } else {
            details = detailsJp;
        }
            
        const closeButton = require('./components/img/ui/close.png'); 
        const prevButton = require('./components/img/ui/prev.png');
        const nextButton = require('./components/img/ui/next.png');
 
        let popupStatus = "";
        
        const popupBanner = require('./components/img/popupbanners/' + this.state.currentGame + '.jpeg') 
        
        const popupPlatform = require('./components/img/platforms/' + platforms[this.state.currentGame] + '.png') 
        
        if (this.state.popupVisible){
          popupStatus = "showPopup"
        } else  if (!this.state.popupVisible){
          popupStatus = "hidePopup"
        }    
   
        return (
            <div id="communities">
                <div id="popup-holder" class={popupStatus}>
                    <div id="popup-bg" onClick = {this.setPopupHidden}>
                    </div>
                    <div id="popup-detail-box">
                        <div id="popup-top">
                            <div id="close-detail-box">
                                <button onClick = {this.setPopupHidden}>
                                    <img src={closeButton} width="100%"/>
                                </button>
                            </div>
                            <div id="prev-project" onClick = {() => this.prevGame()}>
                                <img src={prevButton} width="100%"/>
                            </div>
                            <div id="next-project" onClick = {() => this.nextGame()}>
                               <img src={nextButton} width="100%"/>
                            </div>
                            <div id="game-banner" style={{ backgroundImage: `url(${popupBanner})` }}>
                            </div>
                        </div>
                        <div id="popup-middle">
                            <div id="game-top-left">
                                <div id="game-title">
                                {gameTitles[this.state.currentGame]}
                                </div>
                                <div id="game-company">
                                {companies[this.state.currentGame]}
                                </div>
                            </div>
                            <div id="game-top-right">
                                <div id="game-platform">
                                    <img src={popupPlatform} title = {platforms[this.state.currentGame]}/>
                                </div>
                            </div>
                        </div>
                        <div id="popup-bottom">
                            <div id="game-details">
                                <div dangerouslySetInnerHTML={{ __html: details[this.state.currentGame] }} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="content">
                    <div id="logo">
                        <button onClick = {this.setSection}>
                            <img src={mainLogo} className="main-logo" alt="Grant Wall - Community Manager"/>
                        </button>
                    </div>
                    <div className="title">
                        {title[this.props.currentLanguage]}
                    </div>
                    <div id="feature-games">
                        <FeatureGame
                            game = "age4"
                            company = "relicms"
                            currentLanguage = {this.props.currentLanguage}
                            gameID = "15"
                            setCurrentGame = {this.setCurrentGame}
                        />
                    </div>
                    <div id="other-games">
                    <Game
                        game = "age3"
                        company = "relicms"
                        currentLanguage = {this.props.currentLanguage}
                        gameID = "14"
                        setCurrentGame = {this.setCurrentGame}
                    />
                    <Game
                        game = "age2"
                        company = "relicms"
                        currentLanguage = {this.props.currentLanguage}
                        gameID = "13"
                        setCurrentGame = {this.setCurrentGame}                        />
                    </div>
                    <div id="other-games">
                        <Game
                            game = "heckfire"
                            company = "ata"
                            currentLanguage = {this.props.currentLanguage}
                            gameID = "12"
                            setCurrentGame = {this.setCurrentGame}
                        />
                        <Game
                            game = "smash"
                            company = "ata"
                            currentLanguage = {this.props.currentLanguage}
                            gameID = "11"
                            setCurrentGame = {this.setCurrentGame}                        />
                        <Game
                            game = "kaw"
                            company = "ata"
                            currentLanguage = {this.props.currentLanguage}
                            gameID = "10"
                            setCurrentGame = {this.setCurrentGame}  
                        />
                        <Game
                            game = "meego"
                            company = "ata"
                            currentLanguage = {this.props.currentLanguage}
                            gameID = "9"
                            setCurrentGame = {this.setCurrentGame}  
                        />
                    </div>
                    <div id="feature-games">
                        <FeatureGame
                            game = "pimd"
                            company = "ata"
                            currentLanguage = {this.props.currentLanguage}
                            gameID = "8"
                            setCurrentGame = {this.setCurrentGame}  
                        />
                    </div>
                    <div id="other-games">
                        <Game
                            game = "hco"
                            company = "ogp"
                            currentLanguage = {this.props.currentLanguage}
                            gameID = "7"
                            setCurrentGame = {this.setCurrentGame}  
                        />
                        <Game
                            game = "gundog"
                            company = "ogp"
                            currentLanguage = {this.props.currentLanguage}
                            gameID = "6"
                            setCurrentGame = {this.setCurrentGame}  
                        />
                        <Game
                            game = "hotr"
                            company = "ogp"
                            currentLanguage = {this.props.currentLanguage}
                            gameID = "5"
                            setCurrentGame = {this.setCurrentGame}  
                        />
                        <Game
                            game = "rf"
                            company = "ogp"
                            currentLanguage = {this.props.currentLanguage}
                            gameID = "4"
                            setCurrentGame = {this.setCurrentGame}  
                        />
                        <Game
                            game = "rs"
                            company = "ogp"
                            currentLanguage = {this.props.currentLanguage}
                            gameID = "3"
                            setCurrentGame = {this.setCurrentGame}  
                        />
                        <Game
                            game = "z4"
                            company = "ogp"
                            currentLanguage = {this.props.currentLanguage}
                            gameID = "2"
                            setCurrentGame = {this.setCurrentGame}  
                        />
                    </div>
                    <div id="feature-games">
                        <FeatureGame
                            game = "ms"
                            company = "nexon"
                            currentLanguage = {this.props.currentLanguage}
                            gameID = "1"
                            setCurrentGame = {this.setCurrentGame}  
                        />
                    </div>
                </div>
            </div>
        );
    }
}

class FeatureGame extends Component{
    constructor(props){
        super(props);
        this.state = {}
        this.setCurrentGame = this.setCurrentGame.bind(this);
    }
    
    setCurrentGame(gameID){
        this.props.setCurrentGame(gameID);
    }

    render() {
        const banner = require('./components/img/gamebanners/' + this.props.game + '.jpeg')
        const companylogo = require('./components/img/companylogos/' + this.props.company + '.png')
        const analyticsEventLabel = "Works -> " + this.props.link
        var sectionStyle = {
            width: "100%",
            height: "100%",
            backgroundImage: `url(${banner})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            position: "absolute",
            top: "0px"
        };
        return (
            <div className="game-box-holder" onClick = {() => this.setCurrentGame(parseInt(this.props.gameID))}>
                    <div className="feature game-box">
                        <div className="game-bg" style={sectionStyle}>
                        </div>
                        <div className="game-banner">
                            <img src={companylogo}/>
                        </div>
                    </div>
            </div>
        );
    }
}

class Game extends Component{
    constructor(props){
        super(props);
        this.state = {}
        this.setCurrentGame = this.setCurrentGame.bind(this);
    }
    
    setCurrentGame(gameID){
        this.props.setCurrentGame(gameID);
    }

    render() {
        const banner = require('./components/img/gamebanners/' + this.props.game + '.jpeg') 
        const companylogo = require('./components/img/companylogos/' + this.props.company + '.png')

        const analyticsEventLabel = "Works -> " + this.props.link
        var sectionStyle = {
            width: "100%",
            height: "100%",
            backgroundImage: `url(${banner})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            position: "absolute",
            top: "0px"
        }; 
        if (this.props.link === "#"){
            
        } 
        return (
            <div className="game-box-holder" onClick = {() => this.setCurrentGame(parseInt(this.props.gameID))}>
                    <div className="game-box">
                        <div className="game-bg" style={sectionStyle}>
                        </div>
                        <div className="game-banner">
                          <img src={companylogo}/>
                        </div>
                    </div>
            </div>
        );
    }
}

class Resume extends Component{
    constructor(props){
        super(props);
        this.state = {}
        this.setSection = this.setSection.bind(this);
    }

    setSection(){
        this.props.setSection(1);
    }
    
    render() {      
        let title = {
            en: "experience",
            jp: "職歴"
        };
        let download = {
            en: "Download Resume",
            jp: "履歴書をダウンロード"
        };
        let resumeDownload = {
            en: "/resumes/en/GrantWall-Resume.pdf",
            jp: "/resumes/jp/GrantWall-Resume.pdf"
        };
                                      
        let resumeCompanies = {
            1: "Relic Entertainment",
            2: "A Thinking Ape",
            3: "OGPlanet",
            4: "Nexon America"
        };
        
        let resumeTitlesEn = {
            1: "Community Manager",
            2: "Community & Support Lead",
            3: "Senior Community Manager",
            4: "Community Manager",
            5: "Community Manager / Production Assistant",
            6: "Community Representative / Game Master",
            7: "Freelance Editor",
            8: "Volunteer Forum Moderator"
        };
        
        let resumeDatesEn = {
            1: "Oct 2019 - Present",
            2: "May 2018 - Sept 2019",
            3: "May 2017 - May 2018",
            4: "Dec 2013 - May 2017",
            5: "May 2013 - Nov 2013",
            6: "Sept 2012 - May 2013",
            7: "2012 - 2013",
            8: "Jun 2009 - Dec 2013"

        };
        
        let resumeDetailsEn = {
            1: "<ul><li>Worked alongside our partners at <b>World’s Edge (a division of Microsoft)</b> to support the community and production teams during the lead up to launch for <b>Age of Empires IV</b>, the latest title in the Age of Empires franchise which has spanned over 20 years</li><li>Assisted with the planning and execution of key pre-launch marketing beats and announcements, including <b>Gamescom</b>, <b>E3</b>, the <b>Age of Empires Fan Preview Event</b>, and more</li><li>Assisting with user flighting and reporting during both pre-launch and live service</li><li>Assisting the <b>Microsoft</b> Community team with legacy titles (<b>Age of Empires II: DE, Age of Empires III: DE</b>)</li><li>Organizing and participating in company and partner livestreams on <b>Age of Empires, Relic, SEGA, Xbox, and Mixer</b> channels</li><li>Working with the Community team to plan, execute, and evolve our community strategy and content calendar</li><li>Creating internal and external facing communications (including documentation, blog and social posts, as well as in-game content)</li><li>Liaising between the development teams of both Relic and Microsoft, as well as members of the long-standing Age of Empires community</li><li>Monitoring, collecting, and reporting community sentiment and feedback to senior leadership (both internal and external)</li><li>Providing ongoing community support during live service</li></ul>",
            2: "<ul><li>Established Community & Support Team goals for <b>Kingdoms of Heckfire</b></li><li>Created, reviewed, and revised team policies and workflows on an ongoing basis</li><li>Created and maintained a shared team knowledge base</li><li>Hired and trained new team members</li><li>Managed team members, including one-on-one and weekly team meetings</li><li>Worked with the development team to identify and resolve active issues</li><li>Worked with the localization team to facilitate international members of our community</li><li>Proposed technical solutions for community-based tools and systems</li></ul>",
            3: "<ul><li>Oversaw community planning and development for <b>A Thinking Ape</b>’s upcoming mobile game, <b>Kingdoms of Heckfire</b></li><li>Trained and supported community team members in leading community initiatives for other studio titles</li><li>Created <b>Pre-Registration</b>, <b>Soft-Launch</b>, and <b>Worldwide Launch</b> landing pages</li><li>Worked with the development team to select and implement a new forum solution</li><li>Established and refined community policies and best practices</li><li>Facilitated user on-boarding, testing support, and feedback collection during <b>Closed Beta</b> and <b>Soft Launch<b/></li></ul>",
            4: "<ul><li>Supported various community teams across  a number of mobile gaming titles</li><li>Communicated with online communities through <b>Forums</b>, <b>SNS</b>, and <b>In-Game channels</b></li><li>Managed and created content for social channels over various titles</li><li>Organized and executed live events to increase player engagement</li><li>Organized and followed up with media creation for in-game content</li><li>Managed <b>Volunteer and Beta programs</b> to promote a positive gaming community and obtain valuable insight into player sentiment</li><li>Utilized knowledge of <b>HTML</b>, <b>CSS</b>, and <b>BBCode</b> to create and maintain product webpages and forums</li></ul>",
            5: "<ul><li>Assisted in all areas of production during the launch of a new Free-to-Play title and managed day-to-day operations post-launch</li><li>Contributed to the successful launch of multiple new Free-to-Play titles</li><li>Assisted Project Manager with various production tasks in a variety of roles</li><li>Created, executed, and evaluated in-game and forum events to increase engagement and KPIs</li><li>Managed social platforms for a number of gaming titles</li><li>Created and curated content aimed at increasing community engagement</li><li>Managed and maintained company forums </li><li>Acted as forum moderator and community liaison</li></ul>",
            6: "<ul><li>Enforced the game code of conduct to ensure a safe and fair space for all players</li><li>Monitored game activity to prevent user abuse, bots, and cheating</li><li>Assisted with creation and execution of in-game and community events</li><li>Interacted with the community in-game and through company forums</li><li>Answered user inquiries on a range of game, technical, and other topics</li><li>Utilized internal game tools to troubleshoot and resolve user issues</li></ul>",
            7:"Supplemental freelance work to create gameplay and launch trailers for numerous titles including:<ul><li><b>Tactical Intervention</b>, a First-Person Shooter from the co-creator of Counter Strike</li><li><b>Gundog</b>, a Third-Person Shooter featuring anthropomorphic animal characters</li><li><b>Heva Clonia Online</b>, a 3D monster collection MMORPG</li><li><b>La Tale</b>, a 2D sprite based MMORPG</li><li><b>Zone4</b>, a beat-em-up combat-focused arcade MMORPG</li><li><b>Heroes of the Realm</b>, a web-based card collection and city building game</li></ul> ",
            8: '<ul><li>Assisted Community Manager with the moderating of the online <b>MapleStory</b> community</li><li>Addressed player concerns as well as ensured rules and standards were adhered to</li><li>Reported on community trends and escalated ongoing issues</li><li>Received the <b>Maplestory Humanitarian Award</b> for <i>"[taking] community service to the next level, selflessly giving back to the community by providing guidance and aid to all Maplers -- in-game and out."</i></li></ul>',
        };
        
        let resumeTitlesJp = {
            1: "コミュニティマネージャー",
            2: "コミュニティ＆サポートリード",
            3: "シニアコミュニティマネージャー",
            4: "コミュニティマネージャー",
            5: "コミュニティマネージャー・ゲームプロダクト助手",
            6: "カスタマーサポートスペシャリスト",
            7: "フリーランスのビデオエディター",
            8: "ボランティアコミュニティムモデレーター"
        };
        
        let resumeDatesJp = {
            1: "１０月２０１９年 - 今",
            2: "０５月２０１８年 - ０９月２０１９年",
            3: "０５月２０１７年 - ０５月２０１８年",
            4: "１２月２０１３年 - ０５月２０１７年",
            5: "０５月２０１３年 - １１月２０１３年",
            6: "０９月２０１２年 - ０５月２０１３年",
            7: "２０１２年 - ２０１３年",
            8: "０６月２００９年 - １２月２０１３年"

        };
        
        let resumeDetailsJp = {
            1: "<ul><li>20年以上にわたるAge of Empiresフランチャイズの最新作<b>Age of Empires IV</b>の発売に向けて、パートナーである<b>World's Edge（Microsoftのスタジオ）</b>とともに、コミュニティと制作チームをサポートしました</li><li><b>Gamescom</b>、<b>E3</b>、<b>Age of Empires Fan Preview Event</b>など、発売前の主要なマーケティングビートや発表の企画・実行をサポートしました</li><li>サービス開始前およびサービス開始後のベータテストとレポーティングの支援をしています</li><li>レガシータイトル（<b>Age of Empires II: DE, Age of Empires III: DE</b>）の<b>Microsoft</b>のコミュニティチームをサポートしました</li><li><b>Age of Empires</b>、<b>Relic</b>、<b>SEGA</b>、<b>Xbox</b>、<b>Mixer</b>チャンネルで、会社やパートナーのライブストリームを企画と参加しています</li><li>コミュニティチームと一緒にコミュニティ戦略およびコンテンツカレンダーの企画し、実行し、進化を支援しています</li><li>社内外向けコミュニケーションの作成（ドキュメント、ブログ、ソーシャル投稿、ゲーム内コンテンツなど）をしています</li><li>RelicとMicrosoftの両制作チームとAge of　Empiresの長年のコミュニティーのメンバーとの連携しています</li><li>コミュニティの感情やフィードバックを監視し、収集し、シニアリーダーシップに報告（社内外問わず）をしました</li><li>サービス開始後に継続的なコミュニティサポートの提供 しています</li></ul>",
            2: "<ul><li><b>Kingdoms of Heckfire</b>のコミュニティとサポートチームの目標を設定しました</li><li>チームポリシーやワークフローの作成、見直し、改訂を継続的に実施しました</li><li>チーム共有のナレッジベースの作成と維持しました</li><li>新しいチームメンバーの雇用とトレーニングをしました</li><li>1対1ミーティングや週1回のチームミーティングなど、チームメンバーの管理しました</li><li>開発チームと協力し、進行中の問題を特定し解決した</li><li>ローカライゼーションチームと協力し、海外からの参加者の便宜を図った</li><li>コミュニティベースのツールやシステムに関する技術的なソリューションの提案しました</li></ul>",
            3: "<ul><li><b>A Thinking Ape</b>の新たなモバイルゲーム<b>「Kingdoms of Heckfire」</b>のコミュニティプランニングと開発を統括しました</li><li>他のスタジオタイトルのコミュニティ活動をリードするコミュニティチームメンバーの育成とサポートをしました</li><li><b>前登録</b>、<b>ソフトローンチ</b>、<b>ワールドワイドローンチ</b>のランディングページを作成しました</li><li>開発チームと協力し、新しいフォーラム・ソリューションの選定と実装を実施しました</li><li>コミュニティポリシーとベストプラクティスの確立と改善しました</li><li><b>クローズドβ</b>および<b>ソフトローンチ</b>時のユーザーオンボーディング、テストサポート、フィードバック収集事をしました</li></ul>",
            4:"<ul><li>多数のモバイルゲームタイトルにおいて、様々なコミュニティチームをサポートしました</li><li><b>フォーラム</b>、<b>SNS</b>、<b>ゲーム内チャンネル</b>を通じたオンラインコミュニティとのコミュニケーションをしました</li><li>様々なゲームのソーシャルチャンネルにコンテンツを管理して作成しました</li><li>プレイヤーのエンゲージメントを高めるためのライブイベントの企画して実施をしました</li><li>ゲーム内コンテンツのメディア制作の整理とフォローアップをしました</li><li><b>ボランティアとベータプログラム</b>を管理し、積極的なゲームコミュニティを促進し、プレイヤーの感情に関する貴重な洞察を得ました</li><li><b>HTML</b>、<b>CSS</b>、<b>BBCode</b>の知識を活用し、製品のWebページやフォーラムを作成して管理しました</li></ul>",
            5:"<ul><li>新たなFree-to-Playタイトルの発売前に制作全般を補佐し、発売した後の日々のオペレーションを管理しました</li><li>複数の新たなFree-to-Playタイトルの発売に成功に貢献しました</li><li>プロジェクトマネージャーを補佐し、さまざまな役割で制作業務を遂行しました</li><li>エンゲージメントとKPIを高めるためのゲーム内イベントとフォーラムイベントの作成し、実行し、評価をしました</li><li>多数のゲームタイトルのソーシャルプラットフォームを運営しました</li><li>コミュニティーのエンゲージメントを高めることを目的としたコンテンツの作成とキュレーションをしました</li><li>会社のゲームフォーラムの運営と管理をしました</li><li>フォーラムのモデレーターおよびコミュニティのリエゾンとして活動しました</li></ul>",
            6:"<ul><li>ゲーム内イベントやコミュニティイベントの制作と実施を支援しました</li><li>ゲーム内やフォーラム内を通じてのコミュニティとの交流をしました</li><li>ゲームやテクニカルサポートなど、さまざまなユーザーからの問い合わせへの対応しました</li><li>社内ゲームツールを活用し、ユーザーの問題をトラブルシューティングし解決しました</li></ul>",
            7: "フリーランスとして、以下の数々のタイトルのゲームプレイやローンチトレーラーを補足的に制作しました：<ul><li><b>Tactical Intervention:</b>「カウンターストライク』の共同制作者が贈るファーストパーソン・シューティングゲーム</li><li><b>Gundog:</b> 動物を擬人化したキャラクターが活躍するサードパーソン・シューティングゲーム</li><li><b>Heva Clonia Online:</b> 3Dモンスター収集型MMORPGゲーム</li><li><b>LaTale:</b> 2DスプライトベースのMMORPGゲーム</li><li><b>Zone4:</b> ビートエイムアップ戦闘に特化したアーケードMMORPGゲーム</li><li><b>Heroes of the Realm:</b> ブラウザベースのカードコレクション＆街づくりゲーム</li></ul>",
            8:"<ul><li><b>MapleStory</b>のオンラインコミュニティのモデレーターとして、コミュニティマネージャーを手伝いました</li><li>プレイヤーの悩みに応え、ルールや基準の遵守を徹底しました</li><li>コミュニティの動向を報告し、進行中の問題をエスカレートされました</li><li>「コミュニティサービスを次のレベルに引き上げ、ゲーム内外のすべてのメイプラーに指導と援助を提供し、無私の精神でコミュニティに貢献した」のため<b>「Maplestory Humanitarian Award」</b>を受賞しました。</li></ul>"
        };
    
        let resumeTitle = {}; 
        let resumeDates = {};
        let resumeDetails = {};
        
        if (this.props.currentLanguage == "en"){
            resumeTitle = resumeTitlesEn;
            resumeDates = resumeDatesEn;
            resumeDetails = resumeDetailsEn;
        } else {
            resumeTitle = resumeTitlesJp;
            resumeDates = resumeDatesJp;
            resumeDetails = resumeDetailsJp;
        }
        
        const mainLogo = require('./components/img/logos/' +this.props.currentLanguage +'.png')
        
        return (
            <div id="resume">
                <div id="content" className="content">
                    <div id="logo">
                        <button onClick = {this.setSection}>
                            <img src={mainLogo} className="main-logo" alt="Grant Wall"/>
                        </button>
                    </div>
                    <div className="title">
                        {title[this.props.currentLanguage]}
                    </div>
                    <div id="resume-box">
                       <div id="company">
                            Relic Entertainment
                       </div>
                       
                        <ResumeJob
                            title={resumeTitle[1]}
                            dates={resumeDates[1]}
                            details={resumeDetails[1]}
                        />
                        
                        <br/><div id="company">
                            A Thinking Ape
                        </div>
                        
                        <ResumeJob
                            title={resumeTitle[2]}
                            dates={resumeDates[2]}
                            details={resumeDetails[2]}
                        />
                        <ResumeJob
                            title={resumeTitle[3]}
                            dates={resumeDates[3]}
                            details={resumeDetails[3]}
                        />
                        <ResumeJob
                            title={resumeTitle[4]}
                            dates={resumeDates[4]}
                            details={resumeDetails[4]}
                        />
                        
                        <br/><div id="company">
                            OGPlanet
                        </div>
                        
                        <ResumeJob
                            title={resumeTitle[5]}
                            dates={resumeDates[5]}
                            details={resumeDetails[5]}
                        />
                        <ResumeJob
                            title={resumeTitle[6]}
                            dates={resumeDates[6]}
                            details={resumeDetails[6]}
                        />
                        <ResumeJob
                            title={resumeTitle[7]}
                            dates={resumeDates[7]}
                            details={resumeDetails[7]}
                        />
                        
                        <br/><div id="company">
                            Nexon America
                        </div>
                        
                        <ResumeJob
                            title={resumeTitle[8]}
                            dates={resumeDates[8]}
                            details={resumeDetails[8]}
                        />
                    </div>
                </div>
                <a href={resumeDownload[this.props.currentLanguage]} target="_blank" download>
                    <div id="download-box">
                        <center>
                          <div id="dl-text">
                            {download[this.props.currentLanguage]}
                          </div>
                        </center>
                    </div>
                </a>
            </div>
        );
    }
}

class ResumeJob extends Component{
    constructor(props){
        super(props);
    }

    render() {
        return (
               <div id="position">
                       <div id="job-title">
                           {this.props.title}
                       </div>
                       <div id="job-dates">
                           {this.props.dates}
                       </div>
                       <div id="job-details" dangerouslySetInnerHTML={{__html: this.props.details}}>
                       </div>
                  </div>
        );
    }
}

class Contact extends Component{
    constructor(props){
        super(props);
        this.state = {}
        this.setSection = this.setSection.bind(this);
    }

    setSection(){
        this.props.setSection(1);
    }

    render() {      
        let title = {
            en: "contact",
            jp: "お問い合わせ"
        };
        let subtitle1 = {
            en: "find me online",
            jp: "ＳＮＳ"
        };
        let subtitle2 = {
            en: "shoot me an email",
            jp: "メールで問い合わせる"
        };
        let content = {
            en: "Looking to get in touch?<br>Find me on social media, or send me an email using the link below. ",
            jp: "連絡を取り合いたい？<br>SNSで連絡するやメールを送ってくれてください。"
        };

        let mail = {
            en: 'mailto:grantwall@gmail.com?subject=Website Inquiry',
            jp: 'mailto:grantwall@gmail.com?subject=サイトからお問い合わせ'
        };
        
        const mainLogo = require('./components/img/logos/' +this.props.currentLanguage +'.png')
        
        var sectionStyle = {
            width: "100%",
            height: "100%",
            backgroundImage: `url("")`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            position: "absolute",
            top: "0px"
        }; 
        
        return (
            <div id="contact">
                <div id="content" className="content">
                    <div id="logo">
                        <button onClick = {this.setSection}>
                            <img src={mainLogo} className="main-logo" alt="Grant Wall - Community Manager"/>
                        </button>
                    </div>
                    <div className="title">
                        {title[this.props.currentLanguage]}
                    </div>
                    <div id="contact-box">
                       <div className="about-text" dangerouslySetInnerHTML={{__html: content[this.props.currentLanguage]}}></div>
                    </div>
                    <div id="contact-content">
                        <div className="subtitle sub-1">
                            {subtitle1[this.props.currentLanguage]}
                        </div>
                        <div id="social-media">
                            <ContactSocial
                                type="linkedin"
                                link="https://www.linkedin.com/in/grantwall/"
                            />
                            <ContactSocial
                                type="facebook"
                                link="http://facebook.com/grantwall"
                            />
                            <ContactSocial
                                type="instagram"
                                link="https://instagram.com/grantwall"
                            />
                            <ContactSocial
                                type="twitter"
                                link="https://twitter.com/grantwall"
                            />
                            <ContactSocial
                                type="mastodon"
                                link="https://mstdn.jp/@grantwall"
                            />
                            <ContactSocial
                                type="steam"
                                link="https://steamcommunity.com/id/grantwall"
                            />
                        </div>
                        <div className="subtitle">
                            {subtitle2[this.props.currentLanguage]}
                        </div>
                        <div id="contact-box" className="contact-1">
                            <div className="about-text">
                                <ReactGA.OutboundLink
                                    eventLabel="Contact -> Email Press"
                                    to={mail[this.props.currentLanguage]}
                                    target="_blank"
                                >
                                    grantwall@gmail.com
                                </ReactGA.OutboundLink>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

class ContactSocial extends Component{
    constructor(props){
        super(props);
        this.state = {}
    }

    render() {
        const linkIcon = require('./components/img/social/' + this.props.type +'.png')
        const analyticsEventLabel = "Contact -> " + this.props.link
        return (
                <ReactGA.OutboundLink
                    eventLabel={analyticsEventLabel}
                    to={this.props.link}
                    target="_blank"
                >
                    <img src={linkIcon} width="80px" alt="link"/>
                </ReactGA.OutboundLink>
        );
    }
}

class Navigation extends Component{
    constructor(props){
        super(props);
        this.state = {}
    }

    render() {
        let stringEn = {
            1: "home",
            2: "about me",
            3: "communities",
            4: "experience",
            5: "contact"
        };
        let stringJp = {
            1: "ホーム",
            2: " 自分自身について",
            3: "コミュニティー",
            4: "職歴",
            5: "お問い合わせ"
        };  
        var navItems = [];
        for (var i = 1; i < Object.keys(stringEn).length+1; i++) {
            if (this.props.language === "en"){
                navItems.push(
                    <NavItem
                    key = {"nav"+i}
                    string = {stringEn[i]}
                    icon = {i}
                    setSection = {this.props.setSection}
                    />
                )
            } else {
                navItems.push(
                    <NavItem
                    key = {"nav"+i}
                    string = {stringJp[i]}
                    icon = {i}
                    setSection = {this.props.setSection}
                    />
                )
            }
        }
        return (
            <div id="navigation">
                {navItems}
            </div>
        );
    }
}

class NavItem extends Component{
    constructor(props){
        super(props);
        this.state = {}
        this.setSection = this.setSection.bind(this);
    }

    setSection(){
        this.props.setSection(this.props.icon);
    }

    render() {
        const navIcon = require('./components/img/navicons/' + this.props.icon + '.png')
        const navClass = "nav-circle nav-" + this.props.icon;
        return (
            <div className={navClass}>
                <button onClick = {this.setSection}>
                    <div className="nav-icon"><img src={navIcon} className="icon" alt="icon"/></div>
                    <div className="nav-title">{this.props.string}</div>
                </button>
            </div>
        );
    }
}

class CountryButton extends Component{
    constructor(props){
        super(props);
        this.state = {}
        this.setCountry = this.setCountry.bind(this);
    }

    setCountry(){
        if (this.props.currentLanguage === "en"){
            this.props.setLanguage("jp");
        } else {
            this.props.setLanguage("en");
        }
    }

    render() {
        let languageString;
        if (this.props.currentLanguage === "en"){
            languageString = "日本語";
        } else {
            languageString = "English";
        }
        return (
            <button id="country-button" onClick = {this.setCountry}>
                <div id="language-toggle">
                    {languageString}
                </div>
            </button>
        );
    }
}

export default site;